import { useCallback } from 'react';

import { motion } from 'motion/react';

import { colors } from '../../colors';

import * as css from './Switch.css';

interface SwitchProps {
    onClick?: (val: boolean) => void;
    value?: boolean;
}

const RADIUS_PLUS_PADDING = 18 + 6;

export function Switch({ onClick, value }: SwitchProps) {
    const handleClick = useCallback(() => {
        onClick?.(!value);
    }, [onClick, value]);

    return (
        <motion.button
            className={css.button}
            animate={{
                backgroundColor: value ? '#ffffff' : '#ffffff00',
                boxShadow: value ? `inset 0 0 0 1px ${colors.white}` : `inset 0 0 0 1px ${colors.bluegray[300]}`,
            }}
            transition={{ duration: 0.2 }}
            onClick={handleClick}
        >
            <motion.span
                initial={{
                    left: !value ? 6 : `calc(100% - ${RADIUS_PLUS_PADDING}px)`,
                }}
                animate={{
                    left: !value ? 6 : `calc(100% - ${RADIUS_PLUS_PADDING}px)`,
                }}
                className={css.circle}
            />
        </motion.button>
    );
}
